import { ActionType, FailReason, Step } from '@repo/common';
import { useCallback, useEffect } from 'react';

import { InfoModal } from '@/components/InfoModal/constants';
import { VerificationFailed as VerificationFailedComponent } from '@/components/verification-result/verification-failed';
import { withStep } from '@/hoc/with-step';
import { toggleInfoModalAction } from '@/providers/app-provider/actions';
import { useAppContext } from '@/providers/app-provider/context';
import * as GSC from '@/styles/GlobalStyles';
import { msToSec } from '@/utils/time';
import { isRetryableBffStep, retrySubmitErrorStep } from '@/utils/submit-error';
import { getFailReason } from './fail-reason';

export const VerificationFailed = withStep({ only: [Step.FAIL] })(({ step, workflow }) => {
  const { dispatch, state } = useAppContext();
  const failReason = getFailReason(step);

  const redirectAction = step.action.type === ActionType.REDIRECT ? step.action : null;
  const redirectTimeout = redirectAction?.data.redirectTimeout;
  const redirectTimeoutInSec = redirectTimeout ? msToSec(redirectTimeout) : undefined;
  const redirectPayload = redirectAction?.data.payload;
  const redirectUrl = redirectAction?.data.url;

  const submitErrorContext = state.submitErrorContext;
  const retryable =
    submitErrorContext?.retryable === true && isRetryableBffStep(submitErrorContext.step);

  const redirectOptions = {
    unverifiedUrl: state.customerData?.redirect?.unverifiedUrl ?? '',
    verifiedUrl: state.customerData?.redirect?.verifiedUrl ?? '',
  };

  const onRetry = useCallback(() => {
    retrySubmitErrorStep(dispatch, submitErrorContext, redirectOptions);
  }, [dispatch, redirectOptions, submitErrorContext]);

  useEffect(() => {
    if (failReason === FailReason.SESSION_EXPIRED) {
      dispatch(toggleInfoModalAction(InfoModal.SESSION_EXPIRED));
    }
  }, [dispatch, failReason]);

  return (
    <GSC.FadeInContainer>
      <VerificationFailedComponent
        errorMessage={workflow.context?.tracingId}
        failReason={failReason}
        onRetry={retryable ? onRetry : undefined}
        redirectPayload={redirectPayload}
        redirectTimeoutInSec={redirectTimeoutInSec}
        redirectUrl={redirectUrl}
        retryable={retryable}
      />
    </GSC.FadeInContainer>
  );
});
